import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import CreateEvent from "../../components/Shop/CreateEvent";
import { ADVERTISE_EVENT_FORM_ID } from "../../utils/advertiseEventLink";

const ProfileCreateEvent = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash !== `#${ADVERTISE_EVENT_FORM_ID}`) return;
    const isMobile =
      typeof window !== "undefined" &&
      window.matchMedia("(max-width: 767px)").matches;
    if (!isMobile) return;

    const scrollToForm = () => {
      document.getElementById(ADVERTISE_EVENT_FORM_ID)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    };

    const timers = [80, 300, 600, 1000].map((ms) => window.setTimeout(scrollToForm, ms));
    return () => timers.forEach((id) => window.clearTimeout(id));
  }, [location.pathname, location.hash]);

  return (
    <div
      id={ADVERTISE_EVENT_FORM_ID}
      className="scroll-mt-28 md:scroll-mt-28"
    >
      <CreateEvent />
    </div>
  );
};

export default ProfileCreateEvent;
